import { Link as RouterLink } from 'react-router-dom'
import { t, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'

export function SitemapPage() {
  const { i18n } = useLingui()

  const sections = [
    { label: i18n._(t`Dashboard`), link: '/' },
    { label: i18n._(t`Patients`), link: '/patients' },
    { label: i18n._(t`Consultations`), link: '/consultations' },
    { label: i18n._(t`Agenda`), link: '/agenda' },
    { label: i18n._(t`Tele-expertises`), link: '/expertises' },
    { label: i18n._(t`Meeting links`), link: '/meeting-links' },
  ]

  return (
    <Box sx={{ p: 4, maxWidth: 600 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        <Trans>Sitemap</Trans>
      </Typography>
      <nav aria-label={i18n._(t`Sitemap`)}>
        <List>
          {sections.map((section) => (
            <ListItem key={section.link} disablePadding sx={{ py: 0.5 }}>
              <Link component={RouterLink} to={section.link} underline="hover">
                <ListItemText primary={section.label} />
              </Link>
            </ListItem>
          ))}
        </List>
      </nav>
    </Box>
  )
}
